const colores = {
  rojo: "#E3000B",
  grisOscuro: "#2b323c",
  grisClaro: "#EAEBF0",
  azulOscuro: "#022A3A",
  azulConsulSteel: "#0C24F9",
  naranjaConsulSteel: "#B3BC00",
  celeste: "#4FD0FC",
  activo: "#39FF88",
  inactivo: "#F3E72C",
  rechazado: "#E22022",
  white: "#FFF",
  verde: "#28a745",
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...colores,
};
